<template>
  <div class="wrap">
    <h1 class="row">
      {{translate('exchange-agreement')}}
    </h1>
    <div class="box-content row">
      <h3 class="block-title">{{translate('part-general-data-for-customer')}}</h3>
      <table>
        <tr>
          <td style="width: 60%; border-right: 1rem solid transparent" valign="top">
            <div class="full-height">
              <p class="uppercase">
                {{rfq3.rfq.customerCompany.name}}
              </p>
              <p class="uppercase">
                {{rfq3.rfq.customerCompanyDetail.street}}
              </p>
              <p class="uppercase">
                {{rfq3.rfq.customerCompanyDetail.city}}
              </p>
              <p class="uppercase">
              </p>
              <div class="half">
                <p class="uppercase">
                  {{rfq3.rfq.customerCompanyDetail.country}}
                </p>
              </div><div class="half">
              <p class="uppercase">
                {{rfq3.rfq.customerCompanyDetail.zipCode}}
              </p>
            </div>
            </div>
          </td>
          <td style="width: 50%; border-left: 1rem solid transparent" valign="top">
            <table class="table-auto">
              <tr>
                <td><div class="title text-uppercase mr-2 mb-1">{{translate('contact')}} :</div></td>
                <td><div class="uppercase mb-1">{{rfq3.rfq.customerContact.name}}</div></td>
              </tr>
              <tr>
                <td><div class="title text-uppercase mr-2 mb-1">{{translate('phone')}} :</div></td>
                <td><div class="uppercase mb-1">{{rfq3.rfq.customerContact.phone}}</div></td>
              </tr>
              <tr>
                <td><div class="title text-uppercase mr-2 mb-1">{{translate('po')}} :</div></td>
                <td><div class="uppercase mb-1">{{rfq3.rfq.po}}</div></td>
              </tr>
              <tr>
                <td><div class="title text-uppercase mr-2 mb-1">{{translate('date')}} :</div></td>
                <td><div class="uppercase mb-1">{{rfq3.rfq.poDate | toDate}}</div></td>
              </tr>
            </table>
          </td>
        </tr>
      </table>
    </div>
    <div class="box-content row">
      <h3 class="block-title">{{translate('part-material-end-core-unit-data')}}</h3>
      <p class="title text-capitalize mt-2">
        {{translate('exchange-init')}}
      </p>
      <table>
        <tr>
          <td style="width: 50%; border-right: 1rem solid transparent" valign="top">
            <table class="table-auto">
              <tr>
                <td><div class="title text-uppercase mr-2 mb-1">{{translate('part-number')}} :</div></td>
                <td><div class="uppercase mb-1">{{rfq3.part.partNumber}}</div></td>
              </tr>
              <tr>
                <td><div class="title text-uppercase mr-2 mb-1">{{translate('part-sn')}} :</div></td>
                <td><div class="uppercase mb-1">{{rfq3.partSN}}</div></td>
              </tr>
            </table>
          </td>
          <td style="width: 50%; border-right: 1rem solid transparent" valign="top">
            <table class="table-auto">
              <tr>
                <td><div class="title text-uppercase mr-2 mb-1">{{translate('description')}} :</div></td>
                <td><div class="uppercase mb-1">{{rfq3.part.partDescription}}</div></td>
              </tr>
              <tr>
                <td><div class="title text-uppercase mr-2 mb-1">{{translate('condition')}} :</div></td>
                <td><div class="uppercase mb-1">{{rfq3.exchangeCondition.title}}</div></td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <div class="title mr-2 mb-1 inline">{{translate('remarks')}} :</div><div class="inline">{{rfq3.remarks}}</div>
          </td>
        </tr>
      </table>
    </div>
    <div class="row">
      <h3 class="block-title">{{translate('part-terms')}}</h3>
      <div style="width: 50%">
        <table>
          <tr>
            <td>
              <table class="table-auto">
                <tr>
                  <td>
                    <div class="mr-2 mb-1">
                      <span class="title">{{translate('exch-fee')}} :</span> {{rfq3.currency.title}}
                    </div>
                  </td>
                  <td><div class="uppercase mb-1"> {{rfq3.price}}</div></td>
                </tr>
                <tr>
                  <td><div class="title mr-2 mb-1">{{translate('exchange-type')}} :</div></td>
                  <td><div class="mb-1">{{rfq3.condition.title}}</div></td>
                </tr>
                <tr>
                  <td><div class="title mr-2 mb-1">{{translate('core-due-date')}} :</div></td>
                  <td><div class="mb-1">{{rfq3.coreDueDate | toDate}}</div></td>
                </tr>
              </table>
            </td>
            <td valign="top">
              <table class="table-auto">
                <tr>
                  <td>
                    <div class="mr-2 mb-1">
                      <span class="title">{{translate('core-value')}} :</span> {{rfq3.exchangeCoreValueCurrency.title}}</div>
                  </td>
                  <td><div class="uppercase mb-1"> {{rfq3.exchangeCoreValue}}</div></td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
      <div class="row" v-html="content.html2"></div>
    </div>
    <div class="row">
      <h3 class="block-title">{{translate('part-conditions')}}</h3>
      <div class="row" v-html="content.html1"></div>
      <div>
        <p><strong>{{translate('note-signed-agreement-is-received')}}</strong></p>
        <table>
          <colgroup>
            <col width="60px" />
            <col width="auto" />
            <col width="60px" />
            <col width="100px" />
          </colgroup>
          <tbody>
          <tr style="vertical-align:middle">
            <td><span class="title">{{translate('for')}}: </span></td>
            <td>Bel-Air Express</td>
            <td><span class="title">{{translate('date')}}: </span></td>
            <td>{{rfq3.quoteDate | toDate}}</td>
          </tr>
          <tr>
            <td><span class="title">{{translate('by')}}: </span></td>
            <td colspan="3">{{rfq3.rfq.baxEmployee.name}}</td>
          </tr>
          </tbody>
        </table>
        <p class="mt-2"><strong>{{translate('note-undersigned-confirms-exchange-of-above-referenced')}}</strong></p>
        <table>
          <colgroup>
            <col width="60px" />
            <col width="auto" />
            <col width="60px" />
            <col width="100px" />
          </colgroup>
          <tbody>
          <tr style="vertical-align:middle">
            <td><span class="title">{{translate('for')}}: </span></td>
            <td>{{rfq3.rfq.customerCompany.name}}</td>
            <td><span class="title">{{translate('po')}}: </span></td>
            <td>{{rfq3.rfq.po}}</td>
          </tr>
          <tr style="height:30px">
            <td colspan="4">&nbsp;</td>
          </tr>
          <tr>
            <td><span class="title">{{translate('by')}}: </span></td>
            <td>______________________________________</td>
            <td><span class="title">{{translate('date')}}: </span></td>
            <td>____________</td>
          </tr>
          </tbody>
        </table>
        <p class="mt-2"><span class="title">{{translate('signature-company-stamp')}}: </span><strong></strong><br />&nbsp;<br />&nbsp;<br />&nbsp;<br />&nbsp;<br />________________________________________</p>
      </div>
    </div>
  </div>
</template>
<script>
import { toDate } from '@/utils/filters'

export default {
  name: 'PdfInvoice3',
  props: {
    translate: {
      type: Function
    },
    rfq3: {
      type: Object
    },
    content: {
      type: Object
    }
  },
  filters: {
    toDate: toDate
  }
}
</script>
